import Snappy from '../../../libs/snappy/snappy';

Snappy.Component.SignpostContentPromoQuote = class SignpostContentPromoQuote extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-content-promo-signpost--quote';
	}

	constructor(element) {
		super(element);
	}

	render() {

	}
};



// WEBPACK FOOTER //
// ./components/signpostContentPromoQuote/scripts/signpostContentPromoQuote.js